import { type ColumnMeta, type Table } from '@tanstack/react-table';
import { type SelectOption } from '../Select';

interface SelectMeta {
  filterVariant: 'select';
  filterOptions: SelectOption[];
}
interface SearchMeta {
  filterVariant: 'search';
}

type Meta = ColumnMeta<unknown, unknown> | undefined;

type TableFilterLocalizations = { filter: string; apply: string; cancel: string };

type ColumnMetaWithSelectFilterVariant = Meta & (SelectMeta | SearchMeta);
interface HeaderProps {
  id: string;
  content: React.ReactNode;
  isSorted?: 'asc' | 'desc' | false;
  onClick?: (event: unknown) => void;
  width?: number;
  filterValue?: unknown;
  setFilterValue?: (updater: any) => void;
  meta?: ColumnMetaWithSelectFilterVariant;
}

interface RowProps {
  id: string;
  cells: Array<CellProps>;
}

interface CellProps {
  id: string;
  content: React.ReactNode;
  active?: boolean;
}

export interface TableContainerProps {
  children: React.ReactNode;
}

export interface TableProps {
  children: React.ReactNode;
}

export interface BasicTableProps {
  headers: Array<HeaderProps>;
  rows: Array<RowProps>;
  pagination?: TablePaginationProps;
  tableFilterLocalizations?: TableFilterLocalizations;
}

export interface TablePaginationProps {
  handleNextPage: () => void;
  handlePreviousPage: () => void;
  handleFirstPage: () => void;
  handleLastPage: () => void;
  canGoToPreviousPage: boolean;
  canGoToNextPage: boolean;
  paginationText: string;
}

export interface ReactTableProps<TData = unknown> {
  table: Table<TData>;
  paginationText?: string;
  tableFilterLocalizations?: TableFilterLocalizations;
}

interface TableFilterBaseProps {
  filterValue: unknown;
  setFilterValue: (updater: any) => void;
  localizations?: { filter: string; apply: string; cancel: string };
}

export type TableFilterProps = TableFilterBaseProps & (SelectMeta | SearchMeta);

export function isColumnMetaWithSelectFilterVariant(
  meta: any,
): meta is ColumnMetaWithSelectFilterVariant {
  return meta && (meta.filterVariant === 'select' || meta.filterVariant === 'search');
}
